export default __webpack_public_path__ + "static/media/player-icon.492127a2.png";